import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

/** 鎖
 * 用來綁定在按鈕或連結上，可以帶入自訂一的鎖定 css 類名，否則預設為 lock，
 * 必須自行為鎖定類加上樣式，指令只提供狀態管理和類名綁定
 */
@Directive({
  selector: '[appLock]',
  exportAs: 'lock'
})
export class LockDirective {
  /** 目前元素是否鎖定中 */
  isLock = false;
  /** 鎖定時加在元素上的 css 類名 */
  @Input() lockClass = 'lock';

  constructor(
    private el: ElementRef,
    private render: Renderer2
  ) { }

  lock() {
    this.isLock = true;
    this.render.addClass(this.el.nativeElement as HTMLElement, this.lockClass);
  }

  unlock() {
    this.isLock = false;
    this.render.removeClass(this.el.nativeElement as HTMLElement, this.lockClass);
  }
}
